// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3VZKK","clinicsSelect":"TableHeading_clinicsSelect__121yX"};